import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';

import { AdobeExperiencePlatformLinkedService } from 'app/model/linkedservice/adobe-experience-platform.linkedservice';
import _ from 'lodash';
import { AdobeExperiencePlatformObjectDataset } from 'app/model/dataset/adobe-experience-platform.dataset';
import { completedDateTimeStartMetadata, completedDateTimeEndMetadata } from '../consts/metadata-consts';

export const adobeExperiencePlatformDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AdobeExperiencePlatformObjectDataset).name,
    supportLinkedServiceTypes: [Metamodel.modelFor(AdobeExperiencePlatformLinkedService).name],
    displayName: stringResources.AdobeExperiencePlatform_DisplayText,
    datasetKind: 'file',
    isSource: true,
    isSink: false,
    icon: {
        className: 'svg-i-20x20-AdobeExperiencePlatform'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportAdditionalColumns: true,
    category: ['ServicesApps'],
    notSupportPhysicalType: true,
    notSupportPreviewData: true,
    copySourceControls: [
        completedDateTimeStartMetadata,
        completedDateTimeEndMetadata
    ]
};
